import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchEmployeesList } from "src/Pages/Company/OrganizationStructure/api";

const useFetchEmployeesList = ({
  companyId,
  structureId,
  enabled,
  filterString,
}: {
  companyId: string;
  structureId: string | undefined;
  enabled: boolean;
  filterString?: string;
}) => {
  let filters: string | null = null;

  if (filterString && filterString !== "") {
    const sanitizedFilterString = filterString.replace(/[^\p{L}0-9 ]/gu, "");
    const [firstPhrase, secondPhrase] = sanitizedFilterString.split(" ");

    if (secondPhrase) {
      // eslint-disable-next-line
      filters = `(firstName=like=*${firstPhrase}*;lastName=like=*${secondPhrase}*),(firstName=like=*${secondPhrase}*;lastName=like=*${firstPhrase}*),fk=like=*${filterString}*`;
    } else {
      filters = `(firstName=like=*${firstPhrase}*,lastName=like=*${firstPhrase}*),fk=like=*${filterString}*`;
    }
  }

  return useInfiniteQuery({
    enabled,
    queryKey: ["employees-list", companyId, structureId, filterString],
    queryFn: ({ pageParam }: { pageParam: string | null }) =>
      fetchEmployeesList({ pageParam, companyId, structureId, filters }),
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
  });
};

export default useFetchEmployeesList;
